import React from 'react';

class Navbar extends React.Component {
    state = {
    }

    getNum = (option) => {
        let count = 0
        let keys = Object.getOwnPropertyNames(this.props.state)
        keys.map((key) => {
            return this.props.state[key] === option
                ? count++
                : null
        })
        return count;
    }

    checkNum = () => {
        var status = true
        this.props.categories.map((obj) => {
            return (obj.restriction !== this.getNum(obj.name)) ? status = false : null
        })
        return status
    }
    render() {
        return (
            <>
                <div>
                    <nav className="navbar navbar-expand-md navbar-light fixed-top">
                        <div>
                            <ul className="navbar-nav mr-auto">
                                <li className="nav-item" >
                                    <span title="Score shows the weight of your vote">Your voting power : {this.props.weight}</span>
                                </li>
                            </ul>
                        </div>

                        <div className="collapse navbar-collapse">
                            <ul className="navbar-nav mx-auto">
                                {this.props.categories.map((obj, index) => (
                                    <>
                                        <li className="nav-item">
                                            You have chosen <strong>{this.getNum(obj.name)}</strong>/{obj.restriction} {obj.name}
                                        </li>
                                        {index + 1 === this.props.categories.length
                                            ? null
                                            : <li className="divider-vertical" style={{ width: '1px', background: 'rgba(0,0,0,0.2' }}></li>
                                        }
                                    </>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item" >
                                    <button className={this.checkNum() ? "y-submit" : "n-submit"}
                                        onClick={this.checkNum() ? (e) => this.props.sendData(e) : () => this.props.setErr('Choose the specified number of people from each category to submit')}
                                        style={{ width: "100px !important" }}
                                        // {clicked ? disabled : null}
                                        title="Choose the specified number of people from each category to submit"
                                    >Submit</button>
                                </li>
                            </ul>
                        </div>

                    </nav>
                </div>
            </>
        );
    }
}

export default Navbar;